import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVolumeUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconVolumeUp"><Path d="M13 2.97046V21.0296L5.8043 17.0001H1V7.00005H5.8043L13 2.97046Z" fill="currentColor"/><Path d="M19.75 11.25V8H18.25V11.25H15V12.75H18.25V16H19.75V12.75H23V11.25H19.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVolumeUp;
